import { render } from "./GMapStatic.vue?vue&type=template&id=0b6f392b&scoped=true"
import script from "./GMapStatic.vue?vue&type=script&lang=js"
export * from "./GMapStatic.vue?vue&type=script&lang=js"

import "./GMapStatic.vue?vue&type=style&index=0&id=0b6f392b&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6f392b"]])

export default __exports__